import { useSelector } from 'react-redux';
import React, { useMemo } from 'react';

import { DetailType } from '../../detailTypes';
import DetailCategoryBody from './components/DetailCategoryBody/DetailCategoryBody';
import DetailProductBody from './components/DetailProductBody/DetailProductBody';
import DetailSkuBody from './components/DetailSkuBody/DetailSkuBody';
import useDetailScreenType from '../../hooks/useDetailScreenType';
import { Column } from '@ydistri/ds';
import SKUTableSection from './components/DetailSales/SKUTableSection';
import CalculationsSection from '../CalculationsSection/CalculationsSection';
import { computeRemSize } from '@ydistri/theme';
import DetailProductSizes from './components/DetailProductSizes/DetailProductSizes';
import SkuEntityListsSection from '../SkuEntityListsSection/SkuEntityListsSection';
import { useApplicationConfiguration } from '../../../../hooks/useApplicationConfiguration';

const DetailContentBodySection: React.FC = () => {
  const storeId = useSelector(state => state.detailReducer.storeId);
  const skuId = useSelector(state => state.detailReducer.skuId);
  const productId = useSelector(state => state.detailReducer.productId);
  const detailType = useDetailScreenType(productId, storeId, skuId);
  const { isProductGroupsEnabled } = useApplicationConfiguration();

  const body = useMemo(() => {
    switch (detailType) {
      case DetailType.SKU: {
        return (
          <>
            <DetailSkuBody />
            <CalculationsSection skuId={skuId} />
            <SkuEntityListsSection skuId={skuId} />
          </>
        );
      }
      case DetailType.CATEGORY: {
        return <DetailCategoryBody />;
      }
      case DetailType.PRODUCT: {
        return <DetailProductBody />;
      }
      case DetailType.SKU_NOT_FOUND: {
        return null;
      }
    }
  }, [detailType, skuId]);

  // Sizes must be enabled in ApplicationConfiguration to be displayed
  const showSizesTable =
    isProductGroupsEnabled && (detailType === DetailType.SKU || detailType === DetailType.PRODUCT);

  return (
    <Column $gap={computeRemSize(2)} $flexGrow={0}>
      {body}
      {showSizesTable && (
        <DetailProductSizes key="ProductSizesTable" productId={productId} storeId={storeId} />
      )}
      <SKUTableSection key="SkuTableSection" productId={productId} />
    </Column>
  );
};

export default DetailContentBodySection;
